export type DailyCardId =
  | "double-finisher"
  | "sound-focus"
  | "speed-trial"
  | "deep-breath"
  | "polyglot"
  | "cold-open"
  | "marathon"
  | "perfectionist"
  | "long-player"
  | "golden-take";

export type DailyCard = {
  id: DailyCardId;
  name: string;
  effect: string;
  weight: number;
  rare?: boolean;
};

/* Flipped once per session, after the warm-up. Every card is a positive
   twist on today's session — never a penalty. Weighted random draw;
   "golden-take" is intentionally rare. */
export const DAILY_CARDS: DailyCard[] = [
  { id: "double-finisher", name: "Double Finisher", effect: "2× Clarity on the finisher", weight: 14 },
  { id: "sound-focus", name: "Sound Focus", effect: "All work items target one phoneme (+20% Clarity)", weight: 14 },
  { id: "speed-trial", name: "Speed Trial", effect: "All twisters +20 wpm, +50% Clarity", weight: 12 },
  { id: "deep-breath", name: "Deep Breath", effect: "Extra breath drill, PB chance", weight: 12 },
  { id: "polyglot", name: "Polyglot", effect: "Session runs in your second language (+25% Clarity)", weight: 10 },
  { id: "cold-open", name: "Cold Open", effect: "Skip warm-up, straight to finisher (+30 flat)", weight: 10 },
  { id: "marathon", name: "Marathon", effect: "+3 extra review cards, +40 flat", weight: 10 },
  { id: "perfectionist", name: "Perfectionist", effect: "+100% on any item scored 95%+", weight: 8 },
  { id: "long-player", name: "Long Player", effect: "Every item repeated ×2 (+60% Clarity)", weight: 5 },
  { id: "golden-take", name: "Golden Take", effect: "3× Clarity for the whole session", weight: 5, rare: true },
];
